import dayjs from 'dayjs';
import * as Yup from 'yup';
export const registerValidationSchema = Yup.object().shape({
    FullName: Yup.string()
        .required('Full Name is required')
        .matches(
            /^[A-Za-zÀ-ÿ\u00C0-\u024F\s'-]+$/,
            "Only letters, spaces, hyphens, and apostrophes are allowed."
        ),
    CompanyName: Yup.string()
        .required('Company Name is required')
        .matches(/^[a-zA-Z0-9&\-. ]+$/, 'Only alphanumeric characters, spaces, and limited special characters "&", "-", "." allowed.'),

    MobileNumber: Yup.string()
        .required('Phone Number is required')
        .matches(/^\d{3}-\d{3}-\d{4}$/, 'Phone number must be in the format 999-999-9999'),
    EmailAddress: Yup.string()
        .required('Email Address is required')
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            'Invalid email address.'
        ),
    Password: Yup.string()
        .required('Password is required')
        .test('minLength', value => value && value.length >= 8 && value.length <= 16)
        .test('uppercase', value => /[A-Z]/.test(value))
        .test('lowercase', value => /[a-z]/.test(value))
        .test('number', value => /[0-9]/.test(value))
        .test('special', value => /[!@#$%&*()_+=<>?",'".;/]/.test(value))
        .test('FullName', function (value) {
            const { FullName } = this.parent;
            return value && !value.toLowerCase().includes(FullName.toLowerCase());
        }),
    PortalId: Yup.number()
        .nullable()
        .required('Please select any Portal'),
});

export const passwordValidationSchema = (fullName) => Yup.object().shape({
    Password: Yup.string()
        .required('Password is required')
        .test('minLength', 'Password must be 8 to 16 characters', value => value && value.length >= 8 && value.length <= 16)
        .test('uppercase', 'Password must contain at least one uppercase letter', value => /[A-Z]/.test(value))
        .test('lowercase', 'Password must contain at least one lowercase letter', value => /[a-z]/.test(value))
        .test('number', 'Password must contain at least one number', value => /[0-9]/.test(value))
        .test('special', 'Password must contain at least one special character', value => /[!@#$%&*()_+=<>?",'".;/]/.test(value))
        .test('FullName', 'Password must not contain your full name', function (value) {
            return value && !value.toLowerCase().includes(fullName.toLowerCase());
        }),
        ConfirmPassword: Yup.string()
        .required('Please re-enter your new password')
        .oneOf([Yup.ref('Password'), null], 'Passwords do not match.'),
    
});

export const resetPasswordValidationSchema = (fullName) => Yup.object().shape({
    CurrentPassword: Yup.string()
        .required('Current password is required'),
    Password: Yup.string()
        .required('New Password is required')
        .test('minLength', 'Password must be 8 to 16 characters', value => value && value.length >= 8 && value.length <= 16)
        .test('uppercase', 'Password must contain at least one uppercase letter', value => /[A-Z]/.test(value))
        .test('lowercase', 'Password must contain at least one lowercase letter', value => /[a-z]/.test(value))
        .test('number', 'Password must contain at least one number', value => /[0-9]/.test(value))
        .test('special', 'Password must contain at least one special character', value => /[!@#$%&*()_+=<>?",'".;/]/.test(value))
        .test('FullName', 'Password must not contain your full name', function (value) {
            return value && !value.toLowerCase().includes(fullName.toLowerCase());
        }),
        ConfirmPassword: Yup.string()
        .required('Please re-enter your new password')
        .oneOf([Yup.ref('Password'), null], 'Passwords do not match.'),
});

export const mapCenterValidationSchema = (isMCUserExpired = false) => {

    const baseSchema = {
        FullName: Yup.string().nullable()
        .required('Full Name cannot be empty')
        .matches(
            /^[A-Za-zÀ-ÿ\u00C0-\u024F\s'-]+$/,
            "Only letters, spaces, hyphens, and apostrophes are allowed."
        ),
        HomeStreetAddress1: Yup.string().nullable()
            .matches(/^[a-zA-Z0-9\s,.'-]*$/, 'Address can contain alphanumeric characters and special characters')
            .required('Address cannot be empty'),
        HomeCity: Yup.string().nullable()
            .matches(/^[a-zA-Z\s-]*$/, 'City can contain alphabets, spaces, and hyphens')
            .required('City cannot be empty'),
        HomeState: Yup.number()
            .nullable()
            .required('State cannot be empty'),
        HomeZipCode: Yup.string().nullable()
            .matches(/^\d{5}$/, 'Zip code must be 5 digits')
            .required('Zip code cannot be empty'),
        DLNumber: Yup.string().nullable()
            .matches(/^[a-zA-Z0-9]{1,18}$/, 'Driving License can contain up to 18 alphanumeric characters')
            .required('Driving License cannot be empty'),
        DLState: Yup.number()
            .nullable()
            .required('License state cannot be empty'),
            CompanyName: Yup.string()
            .required('Company Name cannot be empty')
            .matches(/^[a-zA-Z0-9&\-. ]+$/, 'Only alphanumeric characters, spaces, and limited special characters "&", "-", "." allowed.'),
        TaxIdentificationNumber: Yup.string().nullable()
            .required('Tax Identification Number cannot be empty')
            .matches(/^\d{9}$/, 'Tax Identification Number must contain nine numbers'),
        CompanyStreetAddress1: Yup.string().nullable()
            .matches(/^[a-zA-Z0-9\s,.'-]*$/, 'Address can contain alphanumeric characters and special characters')
            .required('Address cannot be empty'),
        CompanyCity: Yup.string().nullable()
            .matches(/^[a-zA-Z\s-]*$/, 'City can contain alphabets, spaces, and hyphens')
            .required('City cannot be empty'),
        CompanyState: Yup.number()
            .nullable()
            .required('State cannot be empty'),
        CompanyZipCode: Yup.string().nullable()
            .matches(/^\d{5}$/, 'Zip code must be 5 digits')
            .required('Zip code cannot be empty'),
        CompanyContactName: Yup.string()
            .nullable()
            .required('Full Name cannot be empty'),
        CompanyContactTelephone: Yup.string()
            .nullable()
            .required('Phone Number cannot be empty')
            .matches(/^\d{3}-\d{3}-\d{4}$/, 'Phone number must be in the format 999-999-9999'),
        CompanyContactEmailAddress: Yup.string()
            .nullable()
            .required('Email Address cannot be empty')
            .matches(
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                'Invalid email address.'
            ),
        AlternateEmail: Yup.string().nullable()
            .required('Email cannot be empty')
            .matches(
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                'Invalid email address.'
            ),
        MobileNumber: Yup.string()
            .nullable()
            .required('Phone Number cannot be empty')
            .matches(/^\d{3}-\d{3}-\d{4}$/, 'Phone number must be in the format 999-999-9999'),
        AlternatePhoneNumber: Yup.string()
            .nullable()
            .required('Phone Number cannot be empty')
            .matches(/^\d{3}-\d{3}-\d{4}$/, 'Phone number must be in the format 999-999-9999'),
    }
    if (isMCUserExpired) {
        baseSchema.NewPassword = Yup.string()
            .nullable()
            .required('New Password is required')
            .test('minLength', 'Password must be 8 to 16 characters', value => !value || (value.length >= 8 && value.length <= 16))
            .test('uppercase', 'Password must contain at least one uppercase letter', value => !value || /[A-Z]/.test(value))
            .test('lowercase', 'Password must contain at least one lowercase letter', value => !value || /[a-z]/.test(value))
            .test('number', 'Password must contain at least one number', value => !value || /[0-9]/.test(value))
            .test('special', 'Password must contain at least one special character', value => !value || /[!@#$%&*()_+=<>?",'".;/]/.test(value))
            .test('FullName', 'Password must not contain your full name', function (value) {
                const { FullName } = this.parent;
                return !value || !value.toLowerCase().includes(FullName?.toLowerCase() || '');
            })
        baseSchema.ConfirmNewPassword = Yup.string()
            .nullable()
            .when('NewPassword', {
                is: (value) => value && value.length > 0,
                then: Yup.string()
                    .required('Please confirm your new password')
                    .oneOf([Yup.ref('NewPassword'), null], 'Passwords do not match'),
                otherwise: Yup.string().notRequired()
            })
    }
    return Yup.object().shape(baseSchema);
};


export const mapCenterAdminValidationSchema = Yup.object().shape({
    FullName: Yup.string().nullable()
        .required('Full Name cannot be empty'),
    AlternateEmail: Yup.string()
        .required('Email cannot be empty')
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            'Invalid email address.'
        ),
    MobileNumber: Yup.string()
        .nullable()
        .required('Phone Number cannot be empty')
        .matches(/^\d{3}-\d{3}-\d{4}$/, 'Phone number must be in the format 999-999-9999'),
    AlternatePhoneNumber: Yup.string()
        .nullable()
        .required('Phone Number cannot be empty')
        .matches(/^\d{3}-\d{3}-\d{4}$/, 'Phone number must be in the format 999-999-9999'),
    HomeStreetAddress1: Yup.string().nullable()
        .matches(/^[a-zA-Z0-9\s,.'-]*$/, 'Address can contain alphanumeric characters and special characters')
        .required('Address cannot be empty'),
    HomeCity: Yup.string().nullable()
        .matches(/^[a-zA-Z\s-]*$/, 'City can contain alphabets, spaces, and hyphens')
        .required('City cannot be empty'),
    HomeState: Yup.number()
        .nullable()
        .required('State cannot be empty'),
    HomeZipCode: Yup.string().nullable()
        .matches(/^\d{5}$/, 'Zip code must be 5 digits')
        .required('Zip code cannot be empty'),
    DLNumber: Yup.string().nullable()
        .matches(/^[a-zA-Z0-9]{1,18}$/, 'Driving License can contain up to 18 alphanumeric characters')
        .required('Driving License cannot be empty'),
    DLState: Yup.number()
        .nullable()
        .required('License state cannot be empty'),
    CompanyName: Yup.string()
        .nullable()
        .required('Company Name cannot be empty'),
    TaxIdentificationNumber: Yup.string().nullable()
        .matches(/^\d{9}$/, 'Tax Identification Number must be 9 digits')
        .required('Tax Identification Number cannot be empty'),
    CompanyStreetAddress1: Yup.string().nullable()
        .matches(/^[a-zA-Z0-9\s,.'-]*$/, 'Address can contain alphanumeric characters and special characters')
        .required('Address cannot be empty'),
    CompanyCity: Yup.string().nullable()
        .matches(/^[a-zA-Z\s-]*$/, 'City can contain alphabets, spaces, and hyphens')
        .required('City cannot be empty'),
    CompanyState: Yup.number()
        .nullable()
        .required('State cannot be empty'),
    CompanyZipCode: Yup.string().nullable()
        .matches(/^\d{5}$/, 'Zip code must be 5 digits')
        .required('Zip code cannot be empty'),
    CompanyContactName: Yup.string()
        .nullable()
        .required('Full Name cannot be empty'),
    CompanyContactTelephone: Yup.string()
        .nullable()
        .required('Phone Number cannot be empty')
        .matches(/^\d{3}-\d{3}-\d{4}$/, 'Phone number must be in the format 999-999-9999'),
    CompanyContactEmailAddress: Yup.string()
        .nullable()
        .required('Email Address cannot be empty')
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            'Invalid email address.'
        ),
});

export const profileValidationSchema = () => Yup.object().shape({
    firstSecurityQuestion: Yup.number()
        .required('Please select the first security question'),
    firstSecurityAnswer: Yup.string()
        .required('First security answer is required'),
    secondSecurityQuestion: Yup.number()
        .required('Please select the second security question'),
    secondSecurityAnswer: Yup.string()
        .required('Second security answer is required'),
    thirdSecurityQuestion: Yup.number()
        .required('Please select the third security question'),
    thirdSecurityAnswer: Yup.string()
        .required('Third security answer is required'),
});

export const otpValidationSchema = Yup.object().shape({
    otp: Yup.string().length(6, "OTP must be exactly 6 digits").required("OTP is required"),
});

export const loginValidationSchema = Yup.object().shape({
    Email: Yup.string()
        .required('Email is required')
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            'Invalid email address.'
        ),
    Password: Yup.string()
        .required('Password is required'),
});

export const resetValidationSchema = Yup.object().shape({
    email: Yup.string()
        .required('Email is required')
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            'Invalid email address.'
        ),
});

export const uploadValidationSchema = Yup.object().shape({
    file: Yup.mixed().test('fileSize', 'File is too large', (value) => {
        return value && value.size <= 1000000; // 1MB limit
    }).required('File is required'),
    documentType: Yup.string()
        .required('Document type is required')
        .nullable(),
});

export const SupplierDetailsSchema = Yup.object().shape({
    CompanyName: Yup.string().nullable().required('Company Name cannot be empty'),
    CompanyWebsite: Yup.string().nullable().required('Company Website cannot be empty')
        .matches(/(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/, 'Please provide a valid website URL'),
    CategoryID: Yup.number().nullable().required('Business Category cannot be empty'),
    ClassificationID: Yup.string().nullable().required('Classification cannot be empty'),
    ServicesProductsProvided: Yup.string().nullable().required('Services cannot be empty'),
    ExpiryDate: Yup.date().nullable().required('Expiry Date of certification cannot be empty'),
    ContactPerson: Yup.string().nullable().required('Contact Person cannot be empty'),
    Title: Yup.string().nullable().required('Title cannot be empty'),
    Email: Yup.string().nullable().required('Email cannot be empty')   
    .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Invalid email address.'
    ),
    PhoneNumber: Yup.string().nullable().required('Phone Number cannot be empty').matches(/^\d{3}-\d{3}-\d{4}$/, 'Phone number must be in the format 999-999-9999'),
    Street: Yup.string().nullable().required('Address cannot be empty'),
    State: Yup.number().nullable().required('State cannot be empty'),
    City: Yup.string().nullable().required('City cannot be empty'),
    ZipCode: Yup.string().nullable().required('Zip code cannot be empty'),
    AgencyID: Yup.number().nullable().required('Agency cannot be empty'),
    AgencyStateID: Yup.number().nullable().required('Agency State cannot be empty'),
});

export const profileInformationSchema = Yup.object().shape({
    FullName: Yup.string().nullable().required('Full Name is required'),
    CompanyName: Yup.string().nullable().required('Company Name is required'),
    MobileNumber: Yup.string()
        .nullable()
        .required('Phone Number is required')
        .matches(/^\d{3}-\d{3}-\d{4}$/, 'Phone number must be in the format 999-999-9999'),
    EmailID: Yup.string().nullable().required('Email Address is required')
    .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Invalid email address.'
    ),
    StateID: Yup.number().nullable().required('State is required'),
    Address: Yup.string().nullable().required('Address is required'),
    ZipCode: Yup.string().nullable().required('Zip code is required'),
    TaxIdentificationNumber: Yup.lazy(() => Yup.string().nullable().when('TaxIdentificationNumber', {
        is: (value) => value != null,
        then: Yup.string().required('Tax Identification Number is required'),
    }))
});

export const supportInformationSchema = Yup.object().shape({
    PortalID: Yup.number().nullable().required('Please select any Portal'),
    PhoneNumber: Yup.string().nullable().notRequired().test("is-valid-phone", "Phone number must be in the format 999-999-9999", value => !value || /^\d{3}-\d{3}-\d{4}$/.test(value)),
    EmailAddress: Yup.string().nullable().required("Email Address is required"),
    Fax: Yup.string().nullable().test(
        'is-valid-fax',
        'Fax must be in the format (e.g. 123-123-1234)',
        value => !value || /^\d{3}-\d{3}-\d{4}$/.test(value)
      )
});

export const newRoleSchema = Yup.object().shape({
    RoleName: Yup.string().required('Role Name is required'),
    PortalId: Yup.number().nullable().required('Please select any Portal'),
    IsWglRole : Yup.boolean(),
    IsCustomerRole : Yup.boolean(),
});

export const newAnnounceMentSchema = Yup.object().shape({
    Title: Yup.string().required('Title is required'),
    PortalID: Yup.number().nullable().required('Please select any Portal'),
    RoleID: Yup.string().nullable().required('Please select any Role'),
    Data: Yup.string().required('Message is required'),
    SelectedDate: Yup.array()
        .of(Yup.date().nullable().required('Select Date is required'))
        .required('Select Date is required')
        .min(2, 'Please select a date range'),
});

export const filterPopupAnnounceMentSchema = Yup.object().shape({
    filterPortalID: Yup.number().nullable().required('Please select any Portal'),
    filterRoleID: Yup.string().nullable().required('Please select any Role')
});

export const newFaqSchema = Yup.object().shape({
    Question: Yup.string().required('Title is required'),
    PortalID: Yup.number().nullable().required('Please select any Portal'),
    Answer: Yup.string().required('Message is required')
});

export const userProfileFilterSchema = Yup.object().shape({
    //  PortalId: Yup.number().nullable().required('Portal is Required'),
    email: Yup.string()
    .nullable()
    .notRequired()
    .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Invalid email address.'
    ),
    fullName:Yup.string().nullable(),
});

export const createMarketerSchema = Yup.object().shape({
    MarketerName: Yup.string()
    .required('Company Name is required')
    .matches(/^[\x20-\x7E]+$/,'Only alphanumeric and special characters are allowed.'),
    // MarketerName: Yup.string().nullable().required('Company Name is Required'),
    ServiceProvider: Yup.number().nullable().required('Service Provider are Required'),
    StartDate: Yup.date().nullable().required('Start Date is required'),
    FolderPath:Yup.string().optional()
});

export const createMarketerGroupSchema = Yup.object().shape({
    GroupName: Yup.string().required('Group Name is required'),
    GroupType: Yup.string().required('Group Type is required'),
    JurisdictionID: Yup.number().nullable().when('GroupType', {
        is: (value) => value?.toLowerCase() !== 'firm',
        then: Yup.number().required('Jurisdiction is required'),
        otherwise: Yup.number().nullable(),
    }),
    StartMonth: Yup.date().required('Start Month is required'),
    BalancingModelID: Yup.string().nullable().required('Balancing Model is required'),
});

export const profileInformationUpdateSchema = Yup.object().shape({
    FullName: Yup.string()
        .required('Full Name cannot be empty')
        .matches(
            /^[A-Za-zÀ-ÿ\u00C0-\u024F\s'-]+$/,
            "Only letters, spaces, hyphens, and apostrophes are allowed."
        ),
    CompanyName: Yup.string().nullable().required('Company Name cannot be empty'),
    MobileNumber: Yup.string()
        .nullable()
        .required('Phone Number cannot be empty')
        .matches(/^\d{3}-\d{3}-\d{4}$/, 'Phone number must be in the format 999-999-9999'),
    EmailID: Yup.string().nullable().required('Email Address cannot be empty')
    .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Invalid email address.'
    ),
});

export const profileInformationMCUpdateSchema = Yup.object().shape({
    FullName: Yup.string()
        .required('Full Name cannot be empty')
        .matches(
            /^[A-Za-zÀ-ÿ\u00C0-\u024F\s'-]+$/,
            "Only letters, spaces, hyphens, and apostrophes are allowed."
        ),
    EmailID: Yup.string().nullable().required('Email Address cannot be empty')
        .email('Email Address is invalid'),
    AlternateEmail: Yup.string().nullable().notRequired()
    .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Invalid email address.'
    ),
    MobileNumber: Yup.string().nullable().required('Phone Number cannot be empty').matches(/^\d{3}-\d{3}-\d{4}$/, 'Phone number must be in the format 999-999-9999'),
    AlternatePhoneNumber: Yup.string().nullable().notRequired().test(
        'valid-format',
        'Phone number must be in the format 999-999-9999',
        (value) => !value || /^\d{3}-\d{3}-\d{4}$/.test(value)
    ),
    HomeStreetAddress1: Yup.string().nullable().required('Home Address cannot be empty'),
    HomeCity: Yup.string().nullable().required('Home City cannot be empty'),
    HomeState: Yup.number().nullable().required('State cannot be empty'),
    HomeZipCode: Yup.string().nullable().required('ZipCode cannot be empty'),
    DLNumber: Yup.string().nullable().required('DL Number cannot be empty'),
    DLState: Yup.number().nullable().required('DL State cannot be empty'),
    CompanyName: Yup.string().nullable().required('Company Name cannot be empty'),
    TaxIdentificationNumber: Yup.string().nullable().required('Tax Identification Number cannot be empty'),
    CompanyStreetAddress1: Yup.string().nullable().required('Company Address cannot be empty'),
    CompanyCity: Yup.string().nullable().required('Company Citycannot be empty'),
    CompanyState: Yup.number().nullable().required('Company State cannot be empty'),
    CompanyZipCode: Yup.string().nullable().required('Company ZipCode cannot be empty'),
    CompanyContactName: Yup.string().nullable().required('Company ContactName cannot be empty'),
    CompanyContactTelephone: Yup.string().nullable().required('Company Contact Telephone cannot be empty').matches(/^\d{3}-\d{3}-\d{4}$/, 'Phone number must be in the format 999-999-9999'),
    CompanyContactEmailAddress: Yup.string().nullable().required('Email Address cannot be empty')
    .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Invalid email address.'
    ),
    // AuthorizedWGLContact: Yup.string().notRequired()
});

export const createPipelineNomination = Yup.object().shape({
    PipelineID: Yup.number().nullable().required('Pipeline is required'),
    ContractID: Yup.string()
    .nullable()
    .required('ContractID is required')
    .matches(/^[\x20-\x7E]+$/,'Only alphanumeric and special characters are allowed.'),
});

export const pipelineNominationFilterSchema = Yup.object().shape({
    MarketerID: Yup.number().nullable().required('Marketer is Required'),
    PipelineID: Yup.number().nullable().required('Pipeline is Required'),
    SelectedDate: Yup.array()
        .of(Yup.date().nullable().required('From - To date is required'))
        .required('From - To is required')
        .min(2, 'Please select a from - to'),
});

export const byFirmFilter = Yup.object().shape({
    StartMonth: Yup.date().required('Month is required')
});

export const MarketerGroupFilterSchema = Yup.object().shape({
    MarketerID: Yup.number().nullable().required('Marketer is Required'),
    GroupName: Yup.number().nullable().notRequired(),
    StartMonth: Yup.date().nullable().notRequired(),
    EndMonth: Yup.date().nullable().notRequired()
})

export const byInterruptibleFilter = Yup.object().shape({
    MarketerID: Yup.number().nullable().required('Marketer is Required'),
    StartMonth: Yup.date().required('Month is required')
});

export const activityFilterSchema = Yup.object().shape({
    SelectedDate: Yup.array()
        .of(Yup.date().nullable().required('From - To date is required'))
        .required('From - To is required')
        .min(2, 'Please select a from - to'),
});

export const accountInquirySchema = Yup.object().shape({
    searchType: Yup.string().required('Search type is required'),
    washingtonGasAccount: Yup.string().nullable().notRequired().test(
        'Account Number must be 12 digits',
      'Invalid account number',
      (value) => {
        if (!value) return true; // no error if user hasn't started typing
        return /^\d{12}$/.test(value); // valid only if exactly 12 digits
      }
    ),
    accountHolder: Yup.object().shape({
        firstName: Yup.string().when('searchType', {
            is: 'Account Holder',
            then: Yup.string().required('First name or organization is required'),
        }),
        lastName: Yup.string(),
    }).default(undefined),
    phoneNumber: Yup.string().when('searchType', {
        is: 'Phone Number',
        then: Yup.string().matches(/^\d{3}-\d{3}-\d{4}$/, 'Invalid phone number').required('Phone number is required').matches(/^\d{3}-\d{3}-\d{4}$/, 'Phone number must be in the format 999-999-9999'),
    }),
    serviceAddress: Yup.object().shape({
        houseNumber: Yup.string().when('searchType', {
            is: 'Service Address',
            then: Yup.string(),
        }),
        apartmentSuite: Yup.string(),
        streetAddress: Yup.string().when('searchType', {
            is: 'Service Address',
            then: Yup.string().required('Street address is required'),
        }),
        city: Yup.string(),
        state: Yup.string(),
    }).default(undefined),
});

export const monthlyStorageSchema = Yup.object().shape({
    ReportDate: Yup.date().required('Month is required'),
    MarketerID: Yup.number().required('Marketer is Required'),
});
export const supplierPendingEnrollmentOrDropSchema = Yup.object().shape({
    ReportDate: Yup.date().required('Month is required'),
    MarketerID: Yup.number().required('Marketer is Required'),
}); 

export const RoleListSchema = Yup.object().shape({
    GroupName: Yup.string().required('Group Name is required'),
    GroupType: Yup.string().required('Group Type is required'),
    JurisdictionID: Yup.number().nullable().when('GroupType', {
        is: (value) => value?.toLowerCase() !== 'firm',
        then: Yup.number().required('Jurisdiction is required'),
        otherwise: Yup.number().nullable(),
    }),
    StartMonth: Yup.date().required('Start Month is required'),
    BalancingModelID: Yup.string().required('Balancing Model is required'),
});
export const customerUsageValidationSchema = Yup.object().shape({
    MarketerName: Yup.number().nullable().notRequired(),
    AccountNumber: Yup.string().nullable().notRequired().test(
        'Account Number must be 12 digits',
      'Invalid account number',
      (value) => {
        if (!value) return true; // no error if user hasn't started typing
        return /^\d{12}$/.test(value); // valid only if exactly 12 digits
      }
    ),
    StartDate: Yup.date().nullable().notRequired(),
    Status:Yup.number().nullable().notRequired(),
})

export const dcReportValidationSchema = Yup.object().shape({
    MarketerName: Yup.number().nullable().notRequired(),
    AccountNumber: Yup.string().nullable().notRequired().test(
        'Account Number must be 12 digits',
      'Invalid account number',
      (value) => {
        if (!value) return true; // no error if user hasn't started typing
        return /^\d{12}$/.test(value); // valid only if exactly 12 digits
      }
    ),
    StartMonth: Yup.date().nullable().notRequired(),
    IsActive: Yup.number().nullable().notRequired()

})

export const eaCreateSeasonSchema = Yup.object().shape({
  JurisdictionId: Yup.number()
    .required("Jurisdiction Name is required")
    .positive("Jurisdiction Name is required"),
  SeasonName: Yup
    .string()
    .required("Season Name is required")
    .max(50, "Season Name must be at most 50 characters"),
  SeasonStart: Yup.date().required("Season Start Date is required").nullable(),
  SeasonEnd: Yup
    .date()
    .required("Season End Date is required")
    .nullable()
    .min(
      Yup.ref("SeasonStart"),
      "Season End Date must be after Season Start Date",
    )
    .test(
      "max-one-year",
      "Season End Date cannot exceed one year from Season Start Date",
      function (value) {
        const { SeasonStart } = this.parent;
        if (!SeasonStart || !value) return true;
        const oneYearLater = dayjs(SeasonStart).add(1, "year");
        return dayjs(value).isSameOrBefore(oneYearLater);
      },
    ),
});

export const eaEditSeasonSchema = Yup.object().shape({
  JurisdictionName: Yup.string().required("Jurisdiction Name is required"),
  SeasonName: Yup
    .string()
    .required("Season Name is required")
    .max(50, "Season Name must be at most 50 characters"),
  SeasonStart: Yup.date().required("Season Start Date is required").nullable(),
  SeasonEnd: Yup
    .date()
    .required("Season End Date is required")
    .nullable()
    .min(
      Yup.ref("SeasonStart"),
      "Season End Date must be after Season Start Date",
    )
    .test(
      "max-one-year",
      "Season End Date cannot exceed one year from Season Start Date",
      function (value) {
        const { SeasonStart } = this.parent;
        if (!SeasonStart || !value) return true;
        const oneYearLater = dayjs(SeasonStart).add(1, "year");
        return dayjs(value).isSameOrBefore(oneYearLater);
      },
    ),
});